import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './TeacherHub.css';

export default function CommunicationHub({ defaultTab = 'announcements' }: any) {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState(defaultTab); // 'announcements' | 'events' | 'messaging'

  return (
    <div className="th-container">
      {/* Header */}
      <div className="th-header-row">
        <div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <h1 className="th-header-title">Communication Hub & Events</h1>
            <span className="th-badge-coming-soon">Coming Soon</span>
          </div>
          <p className="th-header-subtitle">
            A central space for classroom announcements, student messages, school updates, and event schedules.
          </p>
        </div>
        <div style={{ display: 'flex', gap: '10px' }}>
          <button
            type="button"
            className="th-btn-primary"
            onClick={() => navigate('/teacher/messaging')}
          >
            💬 Open Family Messaging
          </button>
          <button
            type="button"
            className="th-btn-secondary"
            onClick={() => navigate('/teacher/calendar')}
          >
            🗓️ Open Calendar
          </button>
        </div>
      </div>

      {/* Tabs */}
      <div className="th-tabs-bar">
        <button
          type="button"
          className={`th-tab-btn ${activeTab === 'announcements' ? 'active' : ''}`}
          onClick={() => setActiveTab('announcements')}
        >
          📢 Classroom Announcements
        </button>
        <button
          type="button"
          className={`th-tab-btn ${activeTab === 'events' ? 'active' : ''}`}
          onClick={() => setActiveTab('events')}
        >
          🗓️ School & Class Events
        </button>
        <button
          type="button"
          className={`th-tab-btn ${activeTab === 'messaging' ? 'active' : ''}`}
          onClick={() => setActiveTab('messaging')}
        >
          💬 Connect with Families
        </button>
      </div>

      {/* Tab: Classroom Announcements (Coming Soon) */}
      {activeTab === 'announcements' && (
        <div>
          <div className="th-card-spotlight">
            <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between' }}>
              <div>
                <span className="th-badge-subtle">Feature In Active Development</span>
                <h2 style={{ fontSize: '1.25rem', margin: '8px 0 6px', color: '#1e293b' }}>
                  Broadcast Announcements & Classroom Newsletters
                </h2>
                <p style={{ color: '#64748b', fontSize: '0.9rem', maxWidth: '720px', lineHeight: 1.5 }}>
                  The Communication Hub will allow teachers to post daily morning announcements, weekly learning previews, field trip reminders, and curriculum highlights directly to families and students.
                </p>
              </div>
              <span style={{ fontSize: '2.5rem' }}>📢</span>
            </div>

            {/* Architecture Preview Cards */}
            <div className="th-preview-grid">
              <div className="th-preview-card">
                <span className="th-preview-icon">📣</span>
                <h3 className="th-preview-title">Classroom Broadcasts</h3>
                <p className="th-preview-desc">
                  Send high-priority reminders or weekly learning digests directly to all enrolled families with one click.
                </p>
                <span className="th-badge-planned">Planned for V2</span>
              </div>

              <div className="th-preview-card">
                <span className="th-preview-icon">🎨</span>
                <h3 className="th-preview-title">Visual Newsletters</h3>
                <p className="th-preview-desc">
                  Curate photo updates, classroom milestones, and standard progression celebrations for family engagement.
                </p>
                <span className="th-badge-planned">Planned for V2</span>
              </div>

              <div className="th-preview-card">
                <span className="th-preview-icon">🔔</span>
                <h3 className="th-preview-title">Automated Action Alerts</h3>
                <p className="th-preview-desc">
                  Notify families automatically when their child's Action Cards or mastery levels receive new evidence.
                </p>
                <span className="th-badge-planned">Planned for V2</span>
              </div>
            </div>
          </div>

          {/* Quick family messaging redirect banner */}
          <div className="th-connect-banner">
            <div>
              <strong style={{ fontSize: '1rem', color: '#1e3a8a' }}>Direct Family Messaging is Live Now</strong>
              <p style={{ margin: '4px 0 0', color: '#3b82f6', fontSize: '0.88rem' }}>
                You can currently chat 1-on-1 with parents and guardians in the Connect Messaging workspace.
              </p>
            </div>
            <button
              type="button"
              className="th-btn-primary"
              onClick={() => navigate('/teacher/messaging')}
            >
              Go to Messaging →
            </button>
          </div>
        </div>
      )}

      {/* Tab: Events (Coming Soon) */}
      {activeTab === 'events' && (
        <div>
          <div className="th-card-spotlight">
            <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between' }}>
              <div>
                <span className="th-badge-subtle">Feature In Active Development</span>
                <h2 style={{ fontSize: '1.25rem', margin: '8px 0 6px', color: '#1e293b' }}>
                  School & Classroom Event Management
                </h2>
                <p style={{ color: '#64748b', fontSize: '0.9rem', maxWidth: '720px', lineHeight: 1.5 }}>
                  Organize school assemblies, parent-teacher conference schedules, testing windows, and academic fairs. Events will automatically sync across the Unified Calendar and Family Portals.
                </p>
              </div>
              <span style={{ fontSize: '2.5rem' }}>🗓️</span>
            </div>

            {/* Scheduled Events area */}
            <div style={{ marginTop: '20px' }}>
              <div style={{
                background: '#f8fafc',
                border: '1px dashed #cbd5e1',
                borderRadius: '12px',
                padding: '36px 20px',
                textAlign: 'center',
              }}>
                <span style={{ fontSize: '2rem', display: 'block', marginBottom: '8px' }}>🗓️</span>
                <h3 style={{ fontSize: '1rem', color: '#334155', margin: '0 0 6px' }}>
                  No Events Scheduled Yet
                </h3>
                <p style={{ fontSize: '0.86rem', color: '#64748b', margin: '0 0 16px' }}>
                  Scheduled school assemblies, parent-teacher conferences, and academic events will sync here and in the Unified Calendar.
                </p>
                <button
                  type="button"
                  className="th-btn-secondary th-btn-sm"
                  onClick={() => navigate('/teacher/calendar')}
                >
                  Open Unified Calendar
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Tab: Direct Messaging shortcut */}
      {activeTab === 'messaging' && (
        <div className="th-card-spotlight" style={{ textAlign: 'center', padding: '48px 24px' }}>
          <span style={{ fontSize: '3rem' }}>💬</span>
          <h2 style={{ fontSize: '1.4rem', margin: '12px 0 8px', color: '#1e293b' }}>
            Direct Family & Student Messaging
          </h2>
          <p style={{ color: '#64748b', fontSize: '0.95rem', maxWidth: '560px', margin: '0 auto 24px' }}>
            Engage directly with families, share progress observations, and discuss next steps in one-on-one conversation threads.
          </p>
          <button
            type="button"
            className="th-btn-primary"
            onClick={() => navigate('/teacher/messaging')}
          >
            Open Active Conversations →
          </button>
        </div>
      )}
    </div>
  );
}
